import get from 'lodash/get';
import CountryLabel from '../components/CountryLabel';

import { UPDATE_DISTRIBUTION_FORM_REDIRECTION } from '../constants/distribution';
import { I18n } from 'react-redux-i18n';

const DEFAULT_STATE = {
  data: {
    kpis: [],
    campaigns: [],
    client_wines_distri: [],
    client_marques_distri: [],
    client_wines_gdv: [],
    client_marques_gdv: []
  },
  kpi: [],
  pos: [],
  price: [],
  raw: [],
  vintage: [],
  synthesis: {
    data: {},
    selectedZone: null,
    selectedMarket: null,
    selectedWine: null,
    loading: false,
    total: {},
    clientWinesOptions: [],
    clientBrandsOptions: [],
    zoneOptions: [],
    marketsOptionsByZone: {},
    marketsOptions: []
  },
  form: {
    market: null,
    wine: [],
    date: null,
    competitors: [],
    network: null,
    currentCampaign: null,
    activeRadioButton: 'ON',
    radioButtons: [
      {
        label: I18n.t('restaurants&caves.networkOptions.restaurant'),
        value: 'ON',
        checked: true
      },
      {
        label: I18n.t('restaurants&caves.networkOptions.cave'),
        value: 'OFF',
        checked: false
      }
    ]
  }
};

export default (state = DEFAULT_STATE, action) => {
  const { type, payload = {} } = action;
  switch (type) {
    case UPDATE_DISTRIBUTION_FORM_REDIRECTION:
      const newForm = handleFormFromRedirection(state, payload);
      return { ...state, form: { ...newForm } };
    default:
      return state;
  }
};

function handleFormFromRedirection(state, payload) {
  const newForm = { ...state.form };
  let { market, network_code } = payload;

  if (market) {
    if (get(state, 'form.market') && get(state, 'data.campaigns')) {
      const campaign = get(state, 'data.campaigns', []).find(
        (item) => get(item, 'market.name') === payload.market
      );
      if (campaign && get(campaign, 'market.id')) {
        market = {
          value: get(campaign, 'market.id'),
          name: get(campaign, 'market.name'),
          code: get(campaign, 'market.country.code'),
          label: (
            <CountryLabel
              city={get(campaign, 'market.name')}
              name={get(campaign, 'market.country.code')}
            />
          )
        };
      }
      newForm.market = market;
    }
  }

  if (network_code) {
    newForm.activeRadioButton = network_code;
  }

  return newForm;
}
